import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  margin-top: 0;\n  margin-bottom: ', 'px;\n'], ['\n  ', ';\n  margin-top: 0;\n  margin-bottom: ', 'px;\n']);

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme';
import { akTypographyMixins } from '@atlaskit/util-shared-styles';

var Header = styled.h4(_templateObject, akTypographyMixins.h600, gridSize() * 2);

export default Header;